var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 8C17.9246 8 19.4507 8.63214 20.5759 9.75736C21.7011 10.8826 22.3333 12.4087 22.3333 14V21H18.3333V14C18.3333 13.4696 18.1225 12.9609 17.7475 12.5858C17.3724 12.2107 16.8637 12 16.3333 12C15.8028 12 15.2941 12.2107 14.919 12.5858C14.544 12.9609 14.3333 13.4696 14.3333 14V21H10.3333V14C10.3333 12.4087 10.9654 10.8826 12.0906 9.75736C13.2158 8.63214 14.742 8 16.3333 8Z",
    stroke: "#115099",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33325 9H2.33325V21H6.33325V9Z",
    stroke: "#115099",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33325 6C5.43782 6 6.33325 5.10457 6.33325 4C6.33325 2.89543 5.43782 2 4.33325 2C3.22868 2 2.33325 2.89543 2.33325 4C2.33325 5.10457 3.22868 6 4.33325 6Z",
    stroke: "#115099",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.60f29493.svg";
export { ForwardRef as ReactComponent };